import "./App.css";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import Home from "./components/Home";
import About from "./components/About";
import Navbar from "./components/Navbar";

import Create from "./components/social-media/Create";
import Edit from "./components/social-media/Edit";
import Delete from "./components/social-media/Delete";

import CreateWebsiteAct from "./components/website-act/CreateWebsiteAct";
import EditWebsiteAct from "./components/website-act/EditWebsiteAct";
import DeleteWebsiteAct from "./components/website-act/DeleteWebsiteAct";

import CreateEvents from "./components/events-conf/CreateEvents";
import EditEvents from "./components/events-conf/EditEvents";
import DeleteEvents from "./components/events-conf/DeleteEvents";

import CreateScientific from "./components/scientific-pub/CreateScientific";
import EditScientific from "./components/scientific-pub/EditScientific";
import DeleteScientific from "./components/scientific-pub/DeleteScientific";
import Variable from "./Config/Variable.js";
import VariableValues from "./VariableValues";
import Monitoring from "./Monitoring/Monitoring.js";

import Impact from "./Impact/Impact.js";
import ImpactForm from "./Impact/Impactform.js";

import EditImpact from "./Impact/ker/EditImpact.js";
import CreateImpact from "./Impact/ker/CreateImpact.js";
import DeleteImpact from "./Impact/ker/DeleteImpact.js";

import Auth from "./components/Auth/Auth";
import Index from "./components/SideBar/Index.js";
import CreateIPR from "./Monitoring/ipr/CreateIPR.js";
import DeleteIPR from "./Monitoring/ipr/DeleteIPR.js";
import EditIPR from "./Monitoring/ipr/EditIPR.js";
import CreateKER from "./Monitoring/ker/CreateKER.js";
import DeleteKER from "./Monitoring/ker/DeleteKER.js";
import EditKER from "./Monitoring/ker/EditKER.js";
import Projects from "./components/Projet/Projects.js";
import PrivateRoute from "./routes/PrivateRoute.js";
import Project from "./components/Projet/Project.js";
import DefinePartners from "./Config/DefinePartners.js";
import Profile from "./components/Profile.js";
import ResetPassword from "./components/Auth/Reset.js";
import ConfirmReset from "./components/Auth/Confirm";
//import Logout from "./components/Auth/Logout"
import { useEffect } from "react";
import FirstPage from "./components/FirstPage/FirstPage.js";
import Contact from "./components/Contact.js";
import KIPEditForm from "./Impact/KIPEditForm.js";
function App() {
  const myWidth = 220;
  const location = useLocation();
  const navigate = useNavigate();
  const token = localStorage.getItem("access_token");
  const project_id = localStorage.getItem("project_id");

  useEffect(() => {
    if (
      !token &&
      location.pathname !== "/login" &&
      !location.pathname.startsWith("/confirm")
    ) {
      navigate("/login");
    }
  }, [token, location.pathname, navigate]);

  return (
    <div className="App">
      {token && project_id && (
        <Navbar
          drawerWidth={myWidth}
          content={
            <Routes>
              <Route
                path="/"
                element={
                  <PrivateRoute>
                    <Home />
                  </PrivateRoute>
                }
              />

              <Route
                path="/about"
                element={
                  <PrivateRoute>
                    <About />
                  </PrivateRoute>
                }
              />
              <Route
                path="/create"
                element={
                  <PrivateRoute>
                    <Create />
                  </PrivateRoute>
                }
              />
              <Route
                path="/edit/:id"
                element={
                  <PrivateRoute>
                    <Edit />
                  </PrivateRoute>
                }
              />
              <Route
                path="/delete/:id"
                element={
                  <PrivateRoute>
                    <Delete />
                  </PrivateRoute>
                }
              />
              <Route
                path="/create-website"
                element={
                  <PrivateRoute>
                    <CreateWebsiteAct />
                  </PrivateRoute>
                }
              />
              <Route
                path="/edit-website/:id"
                element={
                  <PrivateRoute>
                    <EditWebsiteAct />
                  </PrivateRoute>
                }
              />
              <Route
                path="/delete-website/:id"
                element={
                  <PrivateRoute>
                    <DeleteWebsiteAct />
                  </PrivateRoute>
                }
              />
              <Route
                path="/create-events"
                element={
                  <PrivateRoute>
                    <CreateEvents />
                  </PrivateRoute>
                }
              />
              <Route
                path="/edit-events/:id"
                element={
                  <PrivateRoute>
                    <EditEvents />
                  </PrivateRoute>
                }
              />
              <Route
                path="/delete-events/:id"
                element={
                  <PrivateRoute>
                    <DeleteEvents />
                  </PrivateRoute>
                }
              />
              <Route path="/impacts/edit/:kipId" element={<KIPEditForm />} />

              <Route
                path="/create-scientific"
                element={
                  <PrivateRoute>
                    <CreateScientific />
                  </PrivateRoute>
                }
              />
              <Route
                path="/edit-scientific/:id"
                element={
                  <PrivateRoute>
                    <EditScientific />
                  </PrivateRoute>
                }
              />
              <Route
                path="/delete-scientific/:id"
                element={
                  <PrivateRoute>
                    <DeleteScientific />
                  </PrivateRoute>
                }
              />
              <Route
                path="/create_ipr"
                element={
                  <PrivateRoute>
                    <CreateIPR />
                  </PrivateRoute>
                }
              />
              <Route
                path="/monitoring/delete_ipr/:id"
                element={
                  <PrivateRoute>
                    <DeleteIPR />
                  </PrivateRoute>
                }
              />
              <Route
                path="/monitoring/edit_ipr/:id"
                element={
                  <PrivateRoute>
                    <EditIPR />
                  </PrivateRoute>
                }
              />
              <Route
                path="/create_ker"
                element={
                  <PrivateRoute>
                    <CreateKER />
                  </PrivateRoute>
                }
              />
              <Route
                path="/monitoring/delete_ker/:id"
                element={
                  <PrivateRoute>
                    <DeleteKER />
                  </PrivateRoute>
                }
              />
              <Route
                path="/monitoring/edit_ker/:id"
                element={
                  <PrivateRoute>
                    <EditKER />
                  </PrivateRoute>
                }
              />

              <Route
                path="/create_impact"
                element={
                  <PrivateRoute>
                    <CreateImpact />
                  </PrivateRoute>
                }
              />

              <Route
                path="/impact/delete_impact/:id"
                element={
                  <PrivateRoute>
                    <DeleteImpact />
                  </PrivateRoute>
                }
              />
              <Route
                path="/impact/edit_impact/:id"
                element={
                  <PrivateRoute>
                    <EditImpact />
                  </PrivateRoute>
                }
              />
              <Route
                path="/variable"
                element={
                  <PrivateRoute>
                    <Variable />
                  </PrivateRoute>
                }
              />
              <Route
                path="/define_partners"
                element={
                  <PrivateRoute>
                    <DefinePartners />
                  </PrivateRoute>
                }
              />
              <Route
                path="/variableval"
                element={
                  <PrivateRoute>
                    <VariableValues />
                  </PrivateRoute>
                }
              />
              <Route
                path="/monitoring"
                element={
                  <PrivateRoute>
                    <Monitoring />
                  </PrivateRoute>
                }
              />
              <Route
                path="/impacts"
                element={
                  <PrivateRoute>
                    <Impact />
                  </PrivateRoute>
                }
              />
              <Route
                path="/impactForm"
                element={
                  <PrivateRoute>
                    <ImpactForm />
                  </PrivateRoute>
                }
              />
              <Route
                path="/project"
                element={
                  <PrivateRoute>
                    <Project />
                  </PrivateRoute>
                }
              />
              <Route
                path="/projects"
                element={
                  <PrivateRoute>
                    <Projects />
                  </PrivateRoute>
                }
              />
              <Route
                path="/profile"
                element={
                  <PrivateRoute>
                    <Profile />
                  </PrivateRoute>
                }
              />
              {/*    <Route
                path="/contact"
                element={
                  <PrivateRoute>
                    <Contact />
                  </PrivateRoute>
                }
              /> */}
            </Routes>
          }
        />
      )}

      <Routes>
        <Route path="/login" index element={<Auth />} />
        <Route
          path="/selectProject"
          element={
            <PrivateRoute>
              <FirstPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/contact"
          element={
            <PrivateRoute>
              <Contact />
            </PrivateRoute>
          }
        />
        <Route
          path="/confirm/"
          element={<ConfirmReset />}
          key="confirm-reset"
        />
      </Routes>
    </div>
  );
}

export default App;
